import React from 'react';
interface MpuAdBoxProps {
  src: string;
  alt?: string;
  imgWidth?: string;
  imgHeight?: string;
  className?: string;
}
export function MpuAdBox({
  src,
  alt = 'Advertisement',
  imgWidth = '300px',
  imgHeight = '250px',
  className = ''
}: MpuAdBoxProps) {
  return <div className={`flex items-center justify-center ${className}`} style={{
    borderRadius: '18.75px',
    backgroundColor: '#D9D9D9',
    padding: '20px',
    width: '340px'
  }} data-id="element-201">
      <img src={src} alt={alt} style={{
      width: imgWidth,
      height: imgHeight,
      objectFit: 'cover',
      display: 'block'
    }} data-id="element-202" />
    </div>;
}